import React, { useEffect, useState } from "react";
import getAvatarUrl from "../../../utils/get-avatar-url";
import ToggleLinksInput from "../../../parts/inputs/toggle-links-input";
import { Tooltip as ReactTooltip } from "react-tooltip";
import ReactDOMServer from "react-dom/server";
import submit from "submit-form";
import { DATE_FORMATS } from "../../../constants";
import DropdownIcons from "../../../parts/inputs/dropdown-icons";
import { OrganizationCoachesPreviewSectionComponent } from "../../dashboard/settings/manage-coaches/OrganizationCoachesPreviewSectionComponent";
import { getOrganizationCoach } from "../../../utils/user-helpers";
import SvgIcon from "../../../parts/SvgIcon";
import moment from "moment";
import TablistNav from "../../../parts/inputs/TablistNav";
import _ from "lodash";
import ButtonSwitch from "../../../parts/buttonSwitch";
import { usePrevious } from "../../../hooks/usePrevious";
import CoachingDashboardSkeleton from "./CoachingDashboardSkeleton";
import {
  convertToLb,
  roundValue,
  roundToThousand,
  generateTooltipHtml,
} from "./coachingHelpers";
const { DATE_YEAR_FORMAT } = DATE_FORMATS;

const sortItems = [
  {
    title: "Name Ascending",
    src: "/img/svg/sort-amount-up.svg",
    alt: "asc",
    className: "icon-white",
    id: JSON.stringify([["name"], ["asc"]]),
  },
  {
    title: "Name Descending",
    src: "/img/svg/sort-amount-down.svg",
    alt: "desc",
    className: "icon-white",
    id: JSON.stringify([["name"], ["desc"]]),
  },
  {
    title: "Registered Date Ascending",
    src: "/img/svg/sort-amount-up.svg",
    alt: "date asc",
    className: "icon-white",
    id: JSON.stringify([["_id"], ["asc"]]),
  },
  {
    title: "Registered Date Descending",
    src: "/img/svg/sort-amount-down.svg",
    alt: "date desc",
    className: "icon-white",
    id: JSON.stringify([["_id"], ["desc"]]),
  },
];

function View(props, context) {
  const { locals } = context;

  const {
    athletes = [],
    query,
    momentTZ,
    activeMonth,
    today,
    isCurrentMonth,
    isPreviousMonth,
    activeUser,
    coachOrganizationInformation,
    activeUserToRequest,
    organizationRoles = [],
    usersOrganization = {
      organizationActiveUsers: [],
    },
    organizationRoleName,
  } = locals;

  const theme = locals.activeUser.webAppTheme || "dark";
  const { organizationCoach, filterGroup, sort, metric } = query;
  const { organizationActiveUsers = [] } = usersOrganization;
  const athletesGroups = coachOrganizationInformation
    ? coachOrganizationInformation.athletesGroups
    : activeUser.athletesGroups || [];
  const { referAsClients, units } = activeUser;

  const [unitSelected, setUnitSelected] = useState(units);
  //The user is allow to see al the athletes of the coaches
  const isAllowToViewAllOrganizationsCoaches =
    organizationRoleName === "Owner" ||
    organizationRoleName === "Admin" ||
    organizationRoleName === "Nutritionist";

  const clientWord = referAsClients ? "Clients" : "Athletes";

  const groupOptions = isAllowToViewAllOrganizationsCoaches
    ? [
        {
          text: `All ${clientWord}`,
          value: "all",
        },
        {
          text: `All Organization ${clientWord}`,
          value: "organization",
          href: "/actions/refresh?filterGroup=organization",
        },
      ]
    : [
        {
          text: `All ${clientWord}`,
          value: "all",
        },
      ];
  const updateMonth = (amount) => {
    const url = `/actions/refresh`;

    submit(url, {
      method: "GET",
      body: {
        month: activeMonth
          .clone()
          .add(amount, "months")
          .format(DATE_YEAR_FORMAT),
      },
    });
  };

  // 12 should be enough to cover a big portion of the screen
  const emptyRows =
    12 - athletes.length > 0 ? new Array(12 - athletes.length).fill(null) : [];
  const monthDays = moment(activeMonth).daysInMonth();
  const daysForEmptyRows = new Array(monthDays).fill(null);

  const metricsOptions = [
    {
      text: "Workouts",
      value: "workouts",
    },
    {
      text: "Check-Ins",
      value: "check-in",
    },
    {
      text: "Bodyweight logs",
      value: "bodyWeight",
    },
    {
      text: "Steps",
      value: "steps",
    },
    {
      text: "Nutrition",
      value: "nutrients",
    },
    {
      text: "Body measurement logs",
      value: "bodyMeasurements",
    },
    {
      text: "Readiness",
      value: "readiness",
    },
    {
      text: "HRV",
      value: "hrv",
    },
    {
      text: "Progress Photos",
      value: "bodyPhotos",
    },
    {
      text: "Uploaded Videos",
      value: "videos",
    },
  ];
  const coachMetricsOptions = [
    {
      text: "Coach Videos",
      value: "coach-videos",
    },
    {
      text: "Coach Notes",
      value: "coach-notes",
    },
  ];

  const unitOptions = {
    bodyWeight: [
      { name: "Kg", unit: "metric", value: "metric" },
      { name: "Lb", unit: "imperial", value: "imperial" },
    ],
    bodyMeasurements: [
      { name: "Cm", unit: "metric", value: "metric" },
      { name: "Inch", unit: "imperial", value: "imperial" },
    ],
  };

  const metricConfig = {
    workouts: {
      dataKey: "scheduled",
      getConfig: ({
        athlete,
        idx,
        isCurrentMonth,
        today,
        isPreviousMonth,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        const cycle = athlete.cycles[idx];
        let className = "value-Completed";
        if (isCurrentMonth) {
          if (today === idx + 1) className = "value-In Progress";
          else if (today < idx + 1) className = "value-Upcoming";
        } else if (!isPreviousMonth) className = "value-Upcoming";
        let hRef = `/athlete-portal/calendar?athlete=${athlete._id}&date=${dateParam}&view=day&showBack=true`;
        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;

        return { className, cycle, hRef };
      },
    },
    "check-in": {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        let hRef =
          athlete.days[idx]?.status === "completed"
            ? `/athlete-portal/metrics/check-in-summary?athlete=${athlete._id}&checkInDate=${dateParam}&view=day&showBack=true`
            : "";

        if (isFromOtherOrganizationMember && !!hRef)
          hRef += `&organizationCoach=${organizationCoachId}`;

        return {
          className: {
            completed: "value-Completed",
            uncompleted: "value-not-Completed",
            upcoming: "value-Upcoming",
            "in-progress": "value-In ",
            "is-late": "value-late",
          }[athlete.days[idx]?.status],
          hRef,
        };
      },
    },

    bodyWeight: {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,

        unitSelected,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        let hRef = `/athlete-portal/metrics/bodyWeight?athlete=${athlete._id}&date=${dateParam}&view=day&showBack=true`;

        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;
        return {
          className: "",
          hRef,
          displayValue:
            unitSelected === "metric"
              ? roundValue(athlete.days[idx]?.value)
              : roundValue(convertToLb(athlete.days[idx]?.value)),
        };
      },
    },
    steps: {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        let hRef = `/athlete-portal/metrics/step-count?athlete=${athlete._id}&date=${dateParam}&view=day&showBack=true`;
        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;

        return {
          className: "",
          hRef,
          displayValue:
            athlete.days[idx]?.value > 0
              ? roundToThousand(athlete.days[idx]?.value)
              : false,
        };
      },
    },
    nutrients: {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        const dayValues = athlete.days[idx]?.value || {};
        const hasValues =
          (dayValues.fats && dayValues.fats > 0) ||
          (dayValues.carbs && dayValues.carbs > 0) ||
          (dayValues.proteins && dayValues.proteins > 0) ||
          (dayValues.fibers && dayValues.fibers > 0);
        let hRef = hasValues
          ? `/athlete-portal/nutrition?athlete=${athlete._id}&utcDate=${dateParam}&view=day&showBack=true`
          : "";
        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;
        return {
          className: hasValues ? "value-Completed" : "",
          hRef,
        };
      },
    },
    bodyMeasurements: {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        let hRef = `/athlete-portal/metrics/body-measurements?athlete=${athlete._id}&date=${dateParam}&view=day&showBack=true`;
        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;
        return {
          className: "value-Completed",
          hRef,
        };
      },
    },
    readiness: {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        let hRef = `/athlete-portal/metrics/readiness-rate?athlete=${athlete._id}&date=${dateParam}&view=day&showBack=true`;
        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;
        return {
          className: "value-Completed",
          hRef,
          displayValue: Object.values(athlete.days[idx].value)?.reduce(
            (prev, next) => prev + next
          ),
        };
      },
    },
    hrv: {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        let hRef = `/athlete-portal/metrics/hrv?athlete=${athlete._id}&date=${dateParam}&view=day&showBack=true`;
        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;
        return {
          className: "value-Completed",
          hRef,
          displayValue:
            athlete.days[idx]?.value > 0 ? athlete.days[idx].value : false,
        };
      },
    },
    bodyPhotos: {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        let hRef = `/athlete-portal/metrics/progress-photos?athlete=${athlete._id}&date=${dateParam}&view=day&showBack=true`;
        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;
        return {
          className: "value-Completed",
          hRef,
        };
      },
    },
    videos: {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        let hRef = `/athlete-portal/metrics/video-list?athlete=${athlete._id}&date=${dateParam}&showBack=true`;
        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;
        return {
          className: "value-Completed",
          hRef,
        };
      },
    },
    "coach-videos": {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        let hRef = `/athlete-portal/profile?athlete=${athlete._id}&date=${dateParam}&section=coachvideos&showBack=true`;
        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;
        return {
          className: "value-Completed",
          hRef,
        };
      },
    },
    "coach-notes": {
      dataKey: "days",
      getConfig: ({
        athlete,
        idx,
        isFromOtherOrganizationMember,
        organizationCoachId,
        dateParam,
      }) => {
        const isCalendar = athlete.days[idx]?.value === "calendar";
        let hRef = `/athlete-portal/${
          isCalendar ? "calendar" : "metrics/check-in-summary"
        }?athlete=${athlete._id}&${
          isCalendar ? "date" : "checkInDate"
        }=${dateParam}${isCalendar ? "&view=day" : ""}&showBack=true`;
        if (isFromOtherOrganizationMember)
          hRef += `&organizationCoach=${organizationCoachId}`;
        console.log(athlete.days[idx]?.value, isCalendar, hRef);
        return {
          className: "value-Completed",
          hRef,
        };
      },
    },
  };

  const renderCell = (
    athlete,
    idx,
    activeMonth,
    metric,
    isCurrentMonth,
    today,
    isPreviousMonth,
    unitSelected,
    isFromOtherOrganizationMember,
    organizationCoachId
  ) => {
    const { dataKey, getConfig } =
      metricConfig[metric] || metricConfig.workouts;
    if (!athlete[dataKey][idx])
      return (
        <td className={`${metric === "bodyWeight" ? "bodyWeight" : ""}`} />
      );
    const dateParam = `${activeMonth.format("YYYY-MM")}-${
      idx + 1 < 10 ? "0".concat(idx + 1) : idx + 1
    }`;
    const { className, cycle, hRef, displayValue } = getConfig({
      athlete,
      idx,
      activeMonth,
      isCurrentMonth,
      today,
      isPreviousMonth,
      unitSelected,
      isFromOtherOrganizationMember,
      organizationCoachId,
      dateParam,
    });

    return (
      <td
        data-tooltip-html={ReactDOMServer.renderToStaticMarkup(
          generateTooltipHtml(
            athlete,
            cycle,
            idx,
            activeMonth,
            athlete[dataKey][idx].value ||
              athlete[dataKey][idx].status ||
              false,
            referAsClients,
            metric,
            unitSelected,
            today
          )
        )}
        data-html={true}
        className={`${metric === "bodyWeight" ? "bodyWeight" : ""}`}
        key={`athlete-${athlete._id}-day-${idx}`}
        data-tooltip-id={`athlete-${athlete._id}-day-${idx}`}
      >
        {displayValue !== undefined ? (
          <a href={hRef}>{displayValue}</a>
        ) : (
          <a
            className={className}
            href={hRef}
            onClick={(e) => !hRef && e.preventDefault()}
          />
        )}
        <ReactTooltip
          id={`athlete-${athlete._id}-day-${idx}`}
          opacity={1}
          float
        />
      </td>
    );
  };
  const { dataKey } = metricConfig[metric] || metricConfig.workouts;
  const previousMetric = usePrevious(metric);
  const previousFilterGroup = usePrevious(filterGroup);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (previousMetric !== metric || previousFilterGroup !== filterGroup)
      setLoading(false);
  }, [metric, filterGroup]);
  return (
    <main className="coaching-dashboard">
      <header>
        <hgroup className="min-w-[33%]">
          {(metric === "workouts" ||
            metric === "check-in" ||
            metric === "nutrients") && (
            <span>
              {" "}
              <SvgIcon
                src="/img/new-icons/tick-gradient.svg"
                noFilterOnLight={true}
              />{" "}
              Complete
            </span>
          )}
          {metric === "check-in" && (
            <span>
              {" "}
              <SvgIcon
                src="/img/new-icons/red-cross.svg"
                noFilterOnLight={true}
              />{" "}
              Not Complete
            </span>
          )}
          {(metric === "check-in" || metric === "workouts") && (
            <>
              <span className="late">Late</span>
              <span className="in-progress">In Progress</span>
              <span className="upcoming">Upcoming</span>
            </>
          )}
        </hgroup>
        <hgroup>
          <div role="month-handler">
            <div>
              <button onClick={() => updateMonth(-1)}>
                <SvgIcon src="/img/new-icons/arrow-left.svg" alt="prev" />
              </button>
              <div className="labelMonth">
                {activeMonth.format("MMMM YYYY")}
              </div>
              <button onClick={() => updateMonth(1)}>
                <SvgIcon src="/img/new-icons/arrow-right.svg" alt="next" />
              </button>
            </div>
          </div>
        </hgroup>
        <hgroup>
          <DropdownIcons
            title="Sort"
            items={sortItems}
            action={(sort) => {
              submit(`/actions/refresh`, {
                method: "GET",
                body: { sort },
              });
            }}
          />
          {isAllowToViewAllOrganizationsCoaches && (
            <OrganizationCoachesPreviewSectionComponent
              activeUser={activeUser}
              organizationActiveUsers={organizationActiveUsers}
              query={locals.query}
              isFrom="overview"
            />
          )}
          <a
            role="button"
            data-button-type="outline"
            href={`/actions/refresh?month=${momentTZ().format(
              DATE_YEAR_FORMAT
            )}`}
            className="!h-[42px]"
          >
            <span>This Month</span>
          </a>
        </hgroup>
      </header>

      {isAllowToViewAllOrganizationsCoaches && (
        <div role="sub-header" className="flex justify-between gap-4">
          <TablistNav
            name="filterGroup"
            options={[
              ...groupOptions,
              ...(athletesGroups
                ? athletesGroups.map((athleteGroup) => ({
                    text: athleteGroup.name,
                    value: athleteGroup.name,
                  }))
                : []),
            ]}
            callback={() => setLoading(true)}
          />
          {(metric === "bodyWeight" || metric === "bodyMeasurements") && (
            <ButtonSwitch
              options={unitOptions[metric]}
              selectedOption={unitOptions[metric].find(
                (opt) => opt.unit === unitSelected
              )}
              size="small"
              onClickFn={(opt) => setUnitSelected(opt.unit)}
            />
          )}
          {metric === "hrv" && (
            <div className="unit-container">
              <button data-button-type="outline">
                <span>ms</span>
              </button>
            </div>
          )}
        </div>
      )}
      <div
        role="sub-header"
        className={
          ["bodyWeight", "bodyMeasurements", "hrv"].includes(metric)
            ? "flex items-center justify-between"
            : ""
        }
      >
        <div className="flex items-center">
          <hgroup className="pr-4  border-solid border-1r border-[--white-05]">
            <p className="p4 mb-2 opacity-50">
              {referAsClients ? "Clients" : "Athletes"} Overview
            </p>
            <ToggleLinksInput
              name="metric"
              options={metricsOptions}
              callback={() => {
                setLoading(true);
                setUnitSelected(units);
              }}
            />
          </hgroup>
          <hgroup className="pl-4">
            <p className="p4 mb-2 opacity-50">Coach Overview</p>
            <ToggleLinksInput
              name="metric"
              options={coachMetricsOptions}
              callback={() => {
                setLoading(true);
                setUnitSelected(units);
              }}
            />
          </hgroup>
        </div>
      </div>

      {!loading ? (
        <section role="table-wrapper">
          {athletes && athletes.length > 0 ? (
            <table role="report-table">
              <thead role="report-header">
                <tr>
                  <th>Name</th>

                  {!metric || metric === "workouts"
                    ? athletes[0].scheduled.map((scheduled, idx) => (
                        <th
                          className={`${
                            metric === "bodyWeight" ? "bodyWeight" : ""
                          }`}
                        >
                          {idx + 1}
                        </th>
                      ))
                    : athletes[0].days.map((scheduled, idx) => (
                        <th
                          className={`${
                            metric === "bodyWeight" ? "bodyWeight" : ""
                          }`}
                        >
                          {idx + 1 === today ? (
                            <span className="clipped w-fit">{today}</span>
                          ) : (
                            idx + 1
                          )}
                        </th>
                      ))}
                </tr>
              </thead>
              <tbody>
                {athletes &&
                  athletes.length > 0 &&
                  athletes.map((athlete) => {
                    const {
                      isFromOtherOrganizationMember,
                      organizationCoachId,
                    } = getOrganizationCoach(
                      activeUser,
                      athlete._id,
                      organizationActiveUsers
                    );
                    return (
                      <tr key={`athlete-${athlete._id}`}>
                        <td className="no-left-border">
                          <div className="flex gap-2 items-center">
                            <a
                              href={
                                isFromOtherOrganizationMember
                                  ? `/athlete-portal/calendar/?athlete=${athlete._id}&organizationCoach=${organizationCoachId}`
                                  : `/athlete-portal/calendar/?athlete=${athlete._id}`
                              }
                              className="image"
                            >
                              <img
                                src={getAvatarUrl(athlete, null, theme)}
                                loading="lazy"
                                className="profile-picture"
                                width="100%"
                                height="100%"
                              />
                            </a>
                            <a
                              href={
                                isFromOtherOrganizationMember
                                  ? `/athlete-portal/calendar/?athlete=${athlete._id}&organizationCoach=${organizationCoachId}`
                                  : `/athlete-portal/calendar/?athlete=${athlete._id}`
                              }
                              className="name"
                            >
                              {athlete.name || athlete.email}
                            </a>
                          </div>
                        </td>
                        {athlete[dataKey]?.map((_, idx) =>
                          renderCell(
                            athlete,
                            idx,
                            activeMonth,
                            metric,
                            isCurrentMonth,
                            today,
                            isPreviousMonth,
                            unitSelected,
                            isFromOtherOrganizationMember,
                            organizationCoachId
                          )
                        )}
                      </tr>
                    );
                  })}
                {emptyRows.map((item, idx) => (
                  <tr key={`empty-athlete-${idx}`}>
                    <td className="no-left-border">
                      <div className="h-8"></div>
                    </td>
                    {daysForEmptyRows.map((day, idy) => (
                      <td
                        className={`scheduled fixed-width`}
                        key={`empty-athlete-${idx}-day-${idy}`}
                      ></td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="no-athlete-overview-section">
              <p>
                You have no active {referAsClients ? " clients" : " athletes"}
              </p>
              <span>
                This page will display an overview of all your
                {referAsClients ? " clients " : " athletes "}
                training calendars.
              </span>
              <a
                role="button"
                data-button-type="primary"
                href={`/coaching-portal/athletes/?modal[type]=invite-athlete`}
              >
                Invite {referAsClients ? "Client" : "Athlete"}
              </a>
            </div>
          )}
        </section>
      ) : (
        <CoachingDashboardSkeleton rows={10} webAppTheme={theme} />
      )}
    </main>
  );
}

export default View;
